<template>
    <ak-form-decorator
            :id="id"
            :title="title"
            :helpText="helpText"
            :error="error"
            :hasError="hasError"
            :required="required"
            :value="value"
    >
        <span class="ak-form__prefix">
            {{prefix}}
        </span>
        <vue-autonumeric
                v-model="currentValue"
                :options="autoNumericOptions"
                :placeholder="placeholder"
                :readonly="readOnly"
                class="ak-form__control ak-form__control--prefix"
                :class="{
                    'ak-form__control--has-value': currentValue,
                }"
                v-on="$currentListeners"
        />

        <slot name="popover"></slot>
    </ak-form-decorator>
</template>

<script>
import FormElementMixin from "../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementMixin";
import VueAutonumeric from 'vue-autonumeric';

export default {
    name: 'ak-price',
    components: {
        VueAutonumeric
    },
    props: {
        prefix: {
            type: String,
            default: '€'
        },
        decimalPlaces: {
            type: Number,
            default: 2
        },
    },
    mixins: [FormElementMixin],
    computed: {
        /**
         * Get the decimalNumber we need to do calculations width e.g: if we have decimalPlaces 2 => decimalNumber needs to bee 0,01
         * @returns {number}
         */
        decimalNumber() {
            return Math.round(Math.pow(.1, this.decimalPlaces) * 100) / 100;
        },
        /**
         * The Options for autonumeric plugin
         * @returns {{digitGroupSeparator: string, unformatOnHover: boolean, decimalPlaces: number, decimalPlacesShownOnFocus: number, decimalCharacter: string, decimalPlacesShownOnBlur: number, showOnlyNumbersOnFocus: boolean, rawValueDivisor: number}}
         */
        autoNumericOptions() {
            return {
                decimalCharacter: ',',
                digitGroupSeparator: '',
                unformatOnHover: false,
                decimalPlaces: this.decimalPlaces,
                decimalPlacesShownOnFocus: this.decimalPlaces,
                decimalPlacesShownOnBlur: this.decimalPlaces,
                rawValueDivisor: this.decimalNumber,
                emptyInputBehavior: 'null'
            }
        },
        currentValue: {
            get() {
                if (this.isLocalized) {
                    return this.localValue[this.$localeHandler.getActiveLocale()];
                }

                return this.localValue;
            },
            set(e) {
                this.localValue = e;

                this.$emit('input', e === null? e : Math.ceil(this.localValue));
                this.$emit('updateState', this.formatStateOutput(e === null? e : Math.ceil(this.localValue)));
            }
        }
    }
}
</script>
